import React from "react";
import ReactDOM from 'react-dom/client'; // Update import to 'react-dom/client'
import './index.css';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import { initialState } from "./context/initialState"; // Correctly import initialState
import reducer from "./context/Reducer";
import { StateProvider } from "./context/StateProvider";
import { ToastContainer } from 'react-toastify'; // Import ToastContainer
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify styles

// Create a root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the application
root.render(
  <Router>
    <StateProvider initialState={initialState} reducer={reducer}>
      <App />
      <ToastContainer /> {/* Add ToastContainer here */}
    </StateProvider>
  </Router>
);
